export default __webpack_public_path__ + "static/media/checked.e30f7278.svg";